import { render, staticRenderFns } from "./AddModelBindDia.vue?vue&type=template&id=f1c5fc80&scoped=true"
import script from "./AddModelBindDia.vue?vue&type=script&lang=js"
export * from "./AddModelBindDia.vue?vue&type=script&lang=js"
import style0 from "./AddModelBindDia.vue?vue&type=style&index=0&id=f1c5fc80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c5fc80",
  null
  
)

export default component.exports